/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useRef, useState, useEffect } from "react";
import Context from "../../scripts/context/User";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import toast from "react-hot-toast";

import TwoFALogin from "./TwoFA";
import CustomLink from "../../components/Link";
import { validationSchema } from "./validationSchema";
import { WalletContext } from "../../scripts/context/WalletContext";

export default function Login() {
  const { globalState, setGlobalState, getRegistrationStep } =
    useContext(Context);
  const { web3 } = useContext(WalletContext);

  const [state, setState] = useState({
    email: "",
    password: "",
    "g-recaptcha-response": "",
    one_time_password: "",
    remember_me: true,
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [twoFA, setTwoFA] = useState(false);

  const recaptchaRef = useRef(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(
    () =>
      globalState.registration_step === -1 &&
      navigate(globalState.redirect_uri),
    []
  );

  const isError = (field) => errors.find((e) => e.name === field) || false;
  const getErrorMessage = (field) =>
    errors.find((e) => e.name === field)
      ? errors.find((e) => e.name === field).message
      : "";

  const submitForm = (event) => {
    event.preventDefault();
    if (loading) return;

    validationSchema
      .validate(state, { abortEarly: false })
      .then(() => {
        setErrors([]);
        setLoading(true);
        axios
          .post("/login", {
            email: state.email,
            password: state.password,
            "g-recaptcha-response": state["g-recaptcha-response"],
          })
          .then(({ data }) => {
            setLoading(false);
            if (data.two_fa) {
              setTwoFA(true);
            } else {
              if (state.remember_me) {
                localStorage.setItem("token", data.token);
              } else {
                sessionStorage.setItem("token", data.token);
              }
              setGlobalState({
                ...state,
                user: {
                  ...data.user,
                },
                redirect_uri: data.redirect_uri,
                registration_step: getRegistrationStep(data.redirect_uri),
              });
              data.redirect_uri && navigate(data.redirect_uri);
            }
          })
          .catch(({ response }) => {
            toast.error(response.data.message);
            setLoading(false);
            recaptchaRef.current.reset();
          });
      })
      .catch((err) => {
        const err2 = err.inner.map((e) => {
          return {
            name: e.path,
            message: e.message,
          };
        });
        setErrors(err2);
      });
  };

  const checkReCAPTCHA = (captcha) => {
    setState({
      ...state,
      "g-recaptcha-response": captcha,
    });
  };

  /*
    to do:
    . use yup validation - ✅
    . API:
      - check if user exist - ✅
      - if the user not registered yet redirect to the current page  - ✅
      - need to ask backend developer about the google sitekey for ReCAPTCHA - ✅
      - Remember me - ✅
  */

  if (twoFA)
    return <TwoFALogin setTwoFA={setTwoFA} state={state} setState={setState} />;

  return (
    <div className="d-flex flex-column flex-root">
      <div className="login login-3 login-signin-on d-flex flex-row-fluid">
        <div
          className="d-flex flex-center bgi-size-cover bgi-no-repeat flex-row-fluid"
          style={{
            backgroundColor: "rgb(1, 16, 37)",
            backgroundImage:
              "radial-gradient(50% 50% at 50% 50%, rgba(33, 114, 229, 0.3) 0%, rgb(70 132 167 / 0%) 100%)",
          }}
        >
          <div className="login-form text-center text-white p-7 position-relative overflow-hidden">
            <div className="d-flex flex-center mb-15">
              <CustomLink to="/login">
                <img src="img/logo.svg" className="h-50px" alt="" />
              </CustomLink>
            </div>
            <div className="login-signin">
              <div className="mb-10">
                <h3>Sign In</h3>
                <p className="opacity-60 font-weight-bold">
                  Welcome back! Please sign in to continue
                </p>
              </div>
              <form
                onSubmit={submitForm}
                className="form"
                id="kt_login_signin_form"
              >
                <div className="form-group">
                  <input
                    className={`form-control h-auto text-white placeholder-white bg-dark-o-70 rounded-pill border-1 py-4 px-8 mb-5${
                      isError("email") ? " is-invalid" : ""
                    }`}
                    type="text"
                    placeholder="Email"
                    name="email"
                    autocomplete="off"
                    value={state.email}
                    onChange={handleChange}
                  />
                  {isError("email") && (
                    <div className="fv-plugins-message-container">
                      <div
                        data-field="email"
                        data-validator="email"
                        className="fv-help-block"
                      >
                        {getErrorMessage("email")}
                      </div>
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <input
                    className={`form-control h-auto text-white placeholder-white bg-dark-o-70 rounded-pill border-1 py-4 px-8 mb-5${
                      isError("password") ? " is-invalid" : ""
                    }`}
                    type="password"
                    placeholder="Password"
                    name="password"
                    value={state.password}
                    onChange={handleChange}
                  />
                  {isError("password") && (
                    <div className="fv-plugins-message-container">
                      <div
                        data-field="password"
                        data-validator="password"
                        className="fv-help-block"
                      >
                        {getErrorMessage("password")}
                      </div>
                    </div>
                  )}
                </div>
                <div className="mb-4">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6LdSxl4eAAAAAIo3jSjiApiwV8G1l0z-FDUG_e7T"
                    onChange={checkReCAPTCHA}
                    style={{ display: "flex", justifyContent: "center" }}
                    onExpired={() =>
                      setState({ ...state, "g-recaptcha-response": "" })
                    }
                    type="voice"
                  />
                  {isError("g-recaptcha-response") && (
                    <div className="fv-plugins-message-container">
                      <div
                        data-field="g-recaptcha-response"
                        data-validator="g-recaptcha-response"
                        className="fv-help-block text-center"
                      >
                        {getErrorMessage("g-recaptcha-response")}
                      </div>
                    </div>
                  )}
                </div>
                <div className="form-group d-flex flex-wrap justify-content-between align-items-center px-8">
                  <div className="checkbox-inline">
                    <label className="checkbox checkbox-outline checkbox-white text-white m-0">
                      <input
                        type="checkbox"
                        name="remember"
                        checked={state.remember_me}
                        onChange={(e) =>
                          setState({
                            ...state,
                            remember_me: e.target.checked,
                          })
                        }
                      />
                      <span></span>
                      Remember me
                    </label>
                  </div>
                  <CustomLink
                    to="/password/reset"
                    id="kt_login_forgot"
                    className="text-white font-weight-bold"
                  >
                    Forget Password ?
                  </CustomLink>
                </div>
                <div className="form-group text-center mt-10">
                  <button
                    type="submit"
                    id="kt_login_signin_submit"
                    className="btn btn-pill btn-white font-weight-bold opacity-90 px-15 py-3 just-white"
                    disabled={loading}
                  >
                    Sign In
                  </button>
                </div>
              </form>
              {!web3.contracts.presale.data.stopPresale && (
                <div className="mt-10">
                  <span className="opacity-70 mr-4">
                    Don't have an account yet?
                  </span>
                  <CustomLink
                    to="/register"
                    id="kt_login_signup"
                    className="text-white font-weight-bold"
                  >
                    Sign Up
                  </CustomLink>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
